import { extendTheme } from '@chakra-ui/react';
import colors from './colors';
import styles from './styles';
import typography from './typography';
import breakpoints from './breakpoints';

const config = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  styles,
  colors,
  breakpoints,
  ...typography,
});

export default theme;
